import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SpitialArtist from "../../components/artist/wrapper";
import ArtistPageSkeleton from "../../components/common/Skeleton/ArtistPageSkeleton";
import httpService from "../../services/http.service";
import { getCMSApiRoute } from "../../utils/api.utils";

const ArtistPage = () => {
  const { slug } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  async function getData() {
    try {
      const decodedUrl = decodeURI(slug);

      const response = await httpService.get(getCMSApiRoute("artist"), {
        params: {
          pageIndex: 10,
          pageNumber: 1,
          slug: decodedUrl,
          status: 1,
        },
      });

      const { data } = response.data;

      const moviesResponse = await httpService.get(getCMSApiRoute("content"), {
        params: {
          pageIndex: 10,
          pageNumber: 1,
          artist: data?.results[0]?.farsiName,
          status: 1,
        },
      });

      const { data: movieData } = moviesResponse.data;

      return {
        artist: data?.results?.[0],
        movies: movieData.results,
      };
    } catch (error) {
      console.log(
        `Artist SSR Error: ${JSON.stringify(error.response?.config)}`
      );
    }
  }

  useEffect(() => {
    getData(slug).then((data) => {
      setData(data);
      setLoading(false);
    });
  }, []);

  if (loading) return <ArtistPageSkeleton rows={1} cols={5} />;
  return <SpitialArtist data={data} />;
};

export default ArtistPage;
